import { View } from './routeInterfaces';
import { matchPath, useLocation } from '@cthings.co/router-dom';
import { getPath } from './paths';

export const useViewMatch = () => {
  const location = useLocation();

  const matchView = (view: View) =>
    matchPath(
      {
        path: getPath(view as any),
        exact: true,
        strict: false,
      },
      location.pathname,
    );

  return matchView;
};
